// Customer widgets register once, including for AJAX filter/sort replacements.
// Render only near the viewport; reconnecting instances can be observed again.
(() => {
  function observe(element) {
    if (element.ugcObserver || !element.querySelector('script[type="application/json"]')) return;
    if (!('IntersectionObserver' in window)) { element.render(); return; }
    element.ugcObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        element.ugcObserver.disconnect();
        element.ugcObserver = null;
        element.render();
      }
    }, { rootMargin: '500px' });
    element.ugcObserver.observe(element);
  }
(function () {
  if (window.customElements.get('pt-plp-ugc-rail-list')) { return; }
  window.customElements.define('pt-plp-ugc-rail-list', class extends HTMLElement {
    connectedCallback() { observe(this); }
    disconnectedCallback() {
      if (this.ugcObserver) { this.ugcObserver.disconnect(); this.ugcObserver = null; }
    }
    render() {
      var dataEl = this.querySelector('script[type="application/json"]');
      if (!dataEl) { return; }
      if (this.ugcObserver) { this.ugcObserver.disconnect(); this.ugcObserver = null; }
      var candidates;
      try {
        candidates = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(candidates) || candidates.length === 0) { return; }
      for (var i = candidates.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = candidates[i];
        candidates[i] = candidates[j];
        candidates[j] = tmp;
      }
      var chosen = candidates.slice(0, 6);
      var frag = document.createDocumentFragment();
      chosen.forEach(function (item) {
        var itemEl = document.createElement('div');
        itemEl.className = 'pt-plp-ugc-rail__item';
        var img = document.createElement('img');
        img.className = 'theme-img';
        img.src = item.src;
        img.alt = item.alt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        itemEl.appendChild(img);
        frag.appendChild(itemEl);
      });
      dataEl.remove();
      this.appendChild(frag);
      window.ptPlpUgcSelectedIds = chosen.map(function (item) { return item.id; });
    }
  });
})();
(function () {
  if (window.customElements.get('pt-plp-ugc-story')) { return; }
  window.customElements.define('pt-plp-ugc-story', class extends HTMLElement {
    connectedCallback() { observe(this); }
    disconnectedCallback() {
      if (this.ugcObserver) { this.ugcObserver.disconnect(); this.ugcObserver = null; }
    }
    render() {
      var dataEl = this.querySelector('script[type="application/json"]');
      if (!dataEl) { return; }
      if (this.ugcObserver) { this.ugcObserver.disconnect(); this.ugcObserver = null; }
      var candidates;
      try {
        candidates = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(candidates) || candidates.length === 0) { return; }

      var rail = document.querySelector('pt-plp-ugc-rail-list');
    if (rail && typeof rail.render === 'function') { rail.render(); }
      var exclude = Array.isArray(window.ptPlpUgcSelectedIds) ? window.ptPlpUgcSelectedIds : [];
      var pool = candidates.filter(function (item) { return exclude.indexOf(item.id) === -1; });
      if (pool.length === 0) { pool = candidates; }
      var chosen = pool[Math.floor(Math.random() * pool.length)];

      var photoEl = this.querySelector('.pt-plp-ugc-story__photo');
      var contentEl = this.querySelector('.pt-plp-ugc-story__content');
      var starTpl = this.querySelector('.pt-plp-ugc-story__icon-star');

      if (photoEl) {
        var img = document.createElement('img');
        img.className = 'theme-img';
        img.src = chosen.src;
        img.alt = chosen.alt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        photoEl.appendChild(img);
      }

      if (contentEl) {
        if (chosen.rating > 0) {
          var ratingEl = document.createElement('div');
          ratingEl.className = 'pt-plp-ugc-story__rating';
          ratingEl.setAttribute('role', 'img');
          ratingEl.setAttribute('aria-label', chosen.rating + ' out of 5 stars');
          for (var i = 1; i <= 5; i++) {
            var starEl = document.createElement('span');
            starEl.className = 'pt-plp-ugc-story__star' + (i <= chosen.rating ? ' is-filled' : '');
            if (starTpl) {
              starEl.appendChild(starTpl.content.cloneNode(true));
            }
            ratingEl.appendChild(starEl);
          }
          contentEl.appendChild(ratingEl);
        }

        var quoteEl = document.createElement('p');
        quoteEl.className = 'pt-plp-ugc-story__quote';
        quoteEl.textContent = chosen.quote || '';
        contentEl.appendChild(quoteEl);

        if (chosen.name) {
          var nameEl = document.createElement('p');
          nameEl.className = 'pt-plp-ugc-story__name';
          var nameTextEl = document.createElement('span');
          nameTextEl.className = 'pt-plp-ugc-story__name-text';
          nameTextEl.textContent = chosen.name;
          nameEl.appendChild(nameTextEl);
          contentEl.appendChild(nameEl);
        }
      }

      dataEl.remove();
      if (starTpl) { starTpl.remove(); }
    }
  });
})();
})();
